module.exports = "<h1 id=\"分页器--d-pagination\">分页器  d-pagination</h1>\n";